<div class="dialog-confirm">
  <div mat-dialog-content>
    <svg-icon class="logout_timer" src="../../../assets/icons/wall-clock.svg"></svg-icon>
    <p class="modal-h1">
      <span class="lbl-msg">Tu sesión expirará en </span>
      <span class="lbl-seg">{{_timer}} seg</span>
    </p>
  </div>
  <div mat-dialog-actions>
    <button mat-raised-button [mat-dialog-close]="true" cdkFocusInitial>
      <span id="refreshToken">Mantener activa</span>
    </button>
  </div>
</div>
